import React from 'react';
import './Header.css';
import './navigation.json';
import NavSmall from './NavSmall.js';
import logo from './bear.svg';

export const Header = () => (
  <header className="Header">
    <img src={logo} className="App-logo" alt="logo" />           
    <h2>brnfngr</h2>
    <div>
        <NavSmall />
    </div>
  </header>
)


// WEBPACK FOOTER //
// ./src/Header.js